import SoftTypography from "components/SoftTypography";

function InvoiceInfoHeader({ title }) {
  return (
    <SoftTypography
      variant="h6"
      fontWeight="medium"
      textAlign={"center"}
      style={{ backgroundColor: "#00008B" }}
      color={"white"}
    >
      {title}
    </SoftTypography>
  );
}

export default InvoiceInfoHeader;
